import { cloneDeep } from "lodash";
import { enumDataStrategyCreative, platformConfig } from "../constant";

export const isCreativeAdd = (strategyCreativeData) => {
  let count = 0;
  const data = cloneDeep(strategyCreativeData);
  // Loop over each platform in the data.
  for (let platform in data) {
    if (data.hasOwnProperty(platform)) {
      // Loop over each strategy type in the current platform.
      for (let strategyType in data[platform]) {
        if (data[platform].hasOwnProperty(strategyType)) {
          // Loop over each strategy in the current strategy type.
          for (let strategy of data[platform][strategyType]) {
            if (strategy.creatives && strategy.creatives.length > 0) {
              count++;
            }
          }
        }
      }
    }
  }
  return count == 0;
};

export const checkIfEmptyPlatform = (data, platform, mediaType) => {
  if (data.hasOwnProperty(platform)) {
    const keys = mediaType.map((data) => data.value);
    for (let key of keys) {
      if (
        Array.isArray(data[platform][key]) &&
        data[platform][key].length > 0
      ) {
        return false;
      }
    }
    return true;
  } else {
    return true;
  }
};

export const getMediaTypeIdForPlatform = (
  mediaList = [],
  platformList = [],
  platformSelected = "",
  creativeTypeSelected = ""
) => {
  let mediaTypeId = "";
  let mediaTypeArray = [];
  let platformData;
  const isBothDisplayVideo =
    creativeTypeSelected == enumDataStrategyCreative.displayVideoKey;
  if (platformSelected.toLowerCase() == enumDataStrategyCreative.ads.key) {
    platformData = platformList.find((dataPlat) =>
      dataPlat.value.toLowerCase().includes(platformConfig.google.toLowerCase())
    );
  } else if (
    platformSelected.toLowerCase() == enumDataStrategyCreative.viads.key
  ) {
    platformData = platformList.find((dataPlat) =>
      dataPlat.value.toLowerCase().includes(platformConfig.viads.toLowerCase())
    );
  } else {
    platformData = platformList.find((dataPlat) =>
      dataPlat.value.toLowerCase().includes(platformSelected.toLowerCase())
    );
  }

  if (platformData) {
    const mediaData = mediaList.find(
      (dataMedia) =>
        parseInt(dataMedia.platformId) == parseInt(platformData.key)
    );
    if (mediaData) {
      if (isBothDisplayVideo) {
        mediaTypeArray = mediaData.list.map((data) => data.key);
      }
      const mediaTypeData = mediaData.list.find(
        (dataM) =>
          dataM.value.toLowerCase() == creativeTypeSelected.toLowerCase()
      );
      if (mediaTypeData) {
        mediaTypeId = mediaTypeData.key;
      }
    }
  }
  return isBothDisplayVideo ? mediaTypeArray : mediaTypeId;
};

export const getPayloadStrategyCreative = (
  strategyCreativeData,
  mediaType = [],
  platformData = []
) => {
  let payload = {
    [enumDataStrategyCreative.ads.key]: [],
    [enumDataStrategyCreative.meta.key]: [],
    [enumDataStrategyCreative.dv360.key]: [],
    [enumDataStrategyCreative.ion.key]: [],
    [enumDataStrategyCreative.ioh.key]: [],
    [enumDataStrategyCreative.viads.key]: [],
    [enumDataStrategyCreative.tiktok.key]: [],
  };

  const data = cloneDeep(strategyCreativeData);
  // Loop over each platform in the data.
  for (let platform in data) {
    if (data.hasOwnProperty(platform)) {
      // Loop over each strategy type in the current platform.
      for (let strategyType in data[platform]) {
        if (data[platform].hasOwnProperty(strategyType)) {
          // Loop over each strategy in the current strategy type.
          for (let strategy of data[platform][strategyType]) {
            let newStrategy = {
              // mandateId: strategy.mandateId ? strategy.mandateId : 0,
              campaignId: strategy.campaignId ? strategy.campaignId : -1,
              strategyId: strategy.id ? strategy.id : -1,
              creativeType: getMediaTypeIdForPlatform(
                mediaType,
                platformData,
                platform,
                strategyType
              ),
              utm: strategy.utm ? strategy.utm : "",
            };
            if (strategyType == "search") {
              if (strategy.creatives && strategy.creatives.length > 0) {
                newStrategy["heading"] = strategy.creatives[0].heading.map(
                  (dataH) => dataH
                );
                newStrategy["description"] =
                  strategy.creatives[0].description.map((dataD) => dataD);
                newStrategy["landingUrl"] = strategy.creatives[0].landingUrl
                  ? strategy.creatives[0].landingUrl
                  : "";
              }
            }
            // If the strategy type is  not "search", add globalCreativeId to the new strategy object.
            else {
              const globalCreativeIds = strategy.creatives.map(
                (creative) => creative.id
              );
              newStrategy["globalCreativeId"] = globalCreativeIds;
              newStrategy["globalCreativeList"] = strategy.creatives
                ? strategy.creatives
                : [];
            }
            // Push the new strategy object to the corresponding platform array in the payload.
            payload[platform].push(newStrategy);
          }
        }
      }
    }
  }
  return payload;
};

export const isStrategyCreativeDataValid = (
  strategyCreativeData,
  mediaType
) => {
  const data = cloneDeep(strategyCreativeData);
  let count = 0;
  for (let platform in data) {
    const keys = mediaType.map((data) => data.value);
    keys.forEach((key) => {
      if (
        strategyCreativeData[platform][key] &&
        Array.isArray(strategyCreativeData[platform][key])
      ) {
        strategyCreativeData[platform][key].forEach((item) => {
          if (Array.isArray(item.creatives) && item.creatives.length == 0) {
            // Perform validation here
            count++;
          }
        });
      }
    });
  }
  return count == 0;
};

export const getPlatformMediaTypeId = (arrayMedia, stringMedia) => {
  return arrayMedia.find((dataMed) =>
    dataMed.value.toLowerCase().includes(stringMedia.toLowerCase())
  ).key;
};
